import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=13b7629b&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b7629b')) {
      api.createRecord('13b7629b', component.options)
    } else {
      api.reload('13b7629b', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=13b7629b&", function () {
      api.rerender('13b7629b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28LdKzJa255hE/JS/comp/FavElement.vue"
export default component.exports